import { useDataContainer } from "@elsa-zku/lib/helpers/useDataContainer";
import * as React from 'react';
import { disableNotificationsControllerFindBuilding } from "src/api/disableNotifications";
import Filter from "src/disableNotifications/src/components/Filter";
import Top from "src/disableNotifications/src/components/Top";
import Pagination from "src/disableNotifications/src/components/Pagination";
import List from "src/disableNotifications/src/components/List";
import {
  useDisableNotificationsFilter,
  useDisableNotificationsFilterWatcher
} from "src/disableNotifications/src/helpers/disableNotificationsFilter";
import Header from "../Header";
import Loader from "src/components/Loader";
import style from './App.scss';

type Props = {};

const App: React.FunctionComponent<Props> = (props) => {
  const {} = props;
  useDisableNotificationsFilterWatcher();
  const filter = useDisableNotificationsFilter();

  const { data, loading, error } = useDataContainer(React.useCallback(() => {
    if (!filter) return null;
    if (!filter.building_id) return Promise.reject('Дом не выбран');
    return disableNotificationsControllerFindBuilding(filter.building_id);
  }, [filter?.building_id]));

  if (!filter) return null;
  return (
    <div className={style.container}>
      <Top />
      {
        error
          ? <div className={style.error}>{error}</div>
          : loading || !data
            ? <Loader />
            : (
              <>
                <Header address={data.address} />
                <Filter search={filter.search} />
                <List filter={filter} availableYears={data.availableYears} />
                {filter && (
                  <Pagination currentYear={filter.year} years={data.availableYears} />
                )}
              </>
            )
      }
    </div>
  );
};

export default App;